import React from 'react';
import { Box, type Types } from '@fiverr-private/theme';
import type { BaseBadgeProps } from '../../types';
import LazyTooltip from '../helpers/LazyTooltip';

const Badge = ({
  children,
  color = 'white',
  backgroundColor,
  tooltipContent,
  showTooltip = true,
  tooltipPosition = 'top',
  dataTestId,
  appendTooltipToBody,
  disableTooltipFlip,
  disablePadding = false,
}: BaseBadgeProps) => {
  const props: Types.BoxType = {
    color,
    backgroundColor,
    gap: '1',
    height: '20px',
    borderRadius: 'sm',
    display: 'flex',
    alignItems: 'center',
    paddingY: '0',
    paddingX: disablePadding ? '0' : '1.5',
    width: 'fit-content',
    fontSize: 'b_sm',
    lineHeight: 'b_xs',
    fontWeight: 'semibold',
    userSelect: 'none',
    children,
  };

  if (tooltipContent && showTooltip) {
    return (
      <LazyTooltip
        disableFlip={disableTooltipFlip}
        appendToBody={appendTooltipToBody}
        content={tooltipContent}
        position={tooltipPosition}
        as="div"
      >
        <Box data-testid={dataTestId} {...props} />
      </LazyTooltip>
    );
  }

  return <Box data-testid={dataTestId} {...props} />;
};

Badge.displayName = 'Badge';

export default Badge;
